import {Box, Button, SxProps, Theme} from '@mui/material'
import {extendableComponent, iconChevronRight, IconSvg} from '@graphcommerce/next-ui'
import {Trans} from '@lingui/react'
import {Money} from '@graphcommerce/magento-store'
import React from 'react'
import {CartStartCheckoutFragment} from '@graphcommerce/magento-cart/components/CartStartCheckout/CartStartCheckout.gql'

export type CustomCartStartCheckoutProps = CartStartCheckoutFragment & {
  children?: React.ReactNode
  sx?: SxProps<Theme>
}

const name = 'CartStartCheckout' as const
const parts = [
  'checkoutButtonContainer',
  'checkoutButton',
  'checkoutButtonTotal',
  'checkoutMoney',
] as const
const { classes } = extendableComponent(name, parts)

export default function CustomStartCheckoutButton (props: CustomCartStartCheckoutProps) {
  const {
    children,
    sx = [],
    ...cart
  } = props
  const hasTotals = (cart.prices?.grand_total?.value ?? 0) > 0
  const hasErrors = cart.items?.some((item) => (item?.errors?.length ?? 0) > 0)
  const locale = 'pro'

  return (
    <Box
      className={classes.checkoutButtonContainer}
      sx={[
        (theme) => ({ textAlign: 'center', my: theme.spacings.md }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <Button
        id='cart-start-checkout'
        variant='pill'
        color='secondary'
        size='large'
        className={classes.checkoutButton}
        endIcon={<IconSvg src={iconChevronRight} />}
        onClick={(e) => {
          window.location.href = `/${locale}/checkout`
          return false;
        }}
        disabled={!hasTotals || hasErrors}
      >
        <Box
          component='span'
          className={classes.checkoutButtonTotal}
          sx={(theme) => ({
            paddingRight: theme.spacings.xxs,
            '& ~ span.MuiButton-endIcon': { marginLeft: '6px' },
          })}
        >
          <Trans id='Start Checkout' />
        </Box>{' '}
        {hasTotals && (
          <span className={classes.checkoutMoney}>
            <Money {...cart.prices?.grand_total} />
          </span>
        )}
      </Button>

      {children}

      {hasErrors && (
        <Box sx={(theme) => ({ color: 'error.main', mt: theme.spacings.xs })}>
          <Trans id='Some items in your cart contain errors, please update or remove them, then try again.' />
        </Box>
      )}
    </Box>
  )
}


